function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.337h236.31v341.326H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M171.382 144.696v27.826c0 13.831 11.213 25.043 25.043 25.043s25.043-11.213 25.043-25.043v-27.826h-50.086z",
  fill: "#d80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M196.425 182.725c-5.626 0-10.203-4.577-10.203-10.203v-12.986h20.405v12.986c.002 5.626-4.575 10.203-10.202 10.203z",
  fill: "#f0f0f0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M295.672 263.421H251.15c0-8.195-6.645-14.84-14.84-14.84s-14.84 6.645-14.84 14.84h-44.522c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 8.196 6.644 14.84 14.84 14.84h29.682c8.195 0 14.84-6.644 14.84-14.84 8.195 0 14.84-6.644 14.84-14.84h-.494c8.197 0 15.336-6.644 15.336-14.84zm6.099-23.749l-3.896 6.237 4.726 5.632-7.136-1.776-3.898 6.235-.513-7.336-7.136-1.78 6.82-2.755-.512-7.337 4.727 5.636zm-22.735-19.077l-1.528 7.194 6.368 3.677-7.315.77-1.528 7.193-2.992-6.718-7.314.768 5.467-4.922-2.991-6.717 6.367 3.677zm-27.888-10.15l1.024 7.283 7.242 1.277-6.608 3.225 1.022 7.282-5.108-5.291-6.611 3.225 3.453-6.495-5.109-5.289 7.244 1.277zm-29.678 0l3.454 6.494 7.242-1.278-5.108 5.291 3.451 6.494-6.608-3.225-5.11 5.29 1.024-7.281-6.609-3.223 7.241-1.279zm-27.886 10.15l5.465 4.922 6.368-3.677-2.99 6.72 5.464 4.92-7.314-.769-2.992 6.718-1.526-7.194-7.315-.768 6.368-3.677zm-22.735 19.077l6.819 2.756 4.725-5.635-.509 7.339 6.817 2.754-7.137 1.779-.514 7.335-3.895-6.235-7.135 1.777 4.727-5.633z",
  fill: "#ffda44"
});

const SvgAzoresIslands = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAzoresIslands, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/azores-islands.d83f4137.svg";
export { ForwardRef as ReactComponent };